module.exports = __webpack_public_path__ + "img/banner-full-cans2.c0aadbc0.png";